<div class="dialog-container">

  <!-- Header -->
  <div class="dialog-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fa fa-envelope"></i>
      </div>

      <div>
        <h2 class="dialog-title">Liste des envois automatiques</h2>
        <span class="dialog-subtitle">
          Gérez vos rapports programmés
        </span>
      </div>
    </div>

    <button
      mat-icon-button
      class="icon-btn close-btn"
      matTooltip="Fermer"
      (click)="dialogRef.close()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <!-- Table -->
  <div class="table-wrapper">

    <table class="custom-table">

      <thead>
        <tr>
          <th class="emails-col">Email(s)</th>
          <th>Période</th>
          <th>Titre</th>
          <th class="actions-col">Actions</th>
        </tr>
      </thead>

      <tbody>

        <ng-container *ngFor="let item of items">

          <!-- Data row -->
          <tr
            class="data-row"
            [class.is-editing]="editingId === item.id">

            <td class="emails-col">
              <div class="email-cell">
                <div class="email-icon">
                  <i class="fa fa-envelope-o"></i>
                </div>
                <div class="email-list">
                  <span class="email-chip" *ngFor="let mail of getEmailsList(item)">
                    {{ mail }}
                  </span>
                </div>
              </div>
            </td>

            <td>
              <span
                class="period-badge"
                [class.daily]="item.period === 'JOURNALIER'"
                [class.weekly]="item.period === 'HEBDOMADAIRE'"
                [class.monthly]="item.period === 'MENSUEL'">

                <i class="fa fa-clock-o"></i>

                <span *ngIf="item.period === 'JOURNALIER'">
                  Journalier
                </span>

                <span *ngIf="item.period === 'HEBDOMADAIRE'">
                  Hebdomadaire
                </span>

                <span *ngIf="item.period === 'MENSUEL'">
                  Mensuel
                </span>

              </span>
            </td>

            <td>
              <span class="title-cell">
                {{ item.title }}
              </span>
            </td>

            <td class="actions-col">

              <div class="row-actions">

                <button
                  class="row-icon-btn edit"
                  (click)="onEdit(item)"
                  title="Modifier">

                  <i class="fa fa-pencil"></i>
                </button>

                <button
                  class="row-icon-btn delete"
                  (click)="onDelete(item)"
                  title="Supprimer">

                  <i class="fa fa-trash"></i>
                </button>

              </div>

            </td>

          </tr>

          <!-- Edit row -->
          <tr
            class="edit-row"
            *ngIf="editingId === item.id">

            <td colspan="4">

              <div class="edit-container">

                <div class="edit-header">
                  <div class="edit-header-icon">
                    <i class="fa fa-pencil"></i>
                  </div>

                  <div>
                    <span class="edit-title">
                      Modifier l'envoi
                    </span>
                    <span class="edit-subtitle">
                      Modifiez les informations du rapport
                    </span>
                  </div>
                </div>

                <div class="edit-form">

                  <div class="edit-field">
                    <label>Titre</label>

                    <input
                      type="text"
                      class="edit-input"
                      [(ngModel)]="editModel.title"
                      name="editTitre{{ item.id }}"
                      placeholder="Titre du rapport">
                  </div>

                  <div class="edit-field">
                    <label>Email(s)</label>

                    <input
                      type="text"
                      class="edit-input"
                      [(ngModel)]="editModel.emails"
                      name="editEmail{{ item.id }}"
                      placeholder="exemple1@email.com;exemple2@email.com">
                  </div>

                  <div class="edit-field period-field">
                    <label>Période</label>

                    <select
                      class="edit-select"
                      [(ngModel)]="editModel.period"
                      name="editPeriode{{ item.id }}">

                      <option value="JOURNALIER">
                        Journalier
                      </option>

                      <option value="HEBDOMADAIRE">
                        Hebdomadaire
                      </option>

                      <option value="MENSUEL">
                        Mensuel
                      </option>

                    </select>
                  </div>

                  <div class="edit-actions">

                    <button
                      class="validate-btn"
                      (click)="onValidate(item)"
                      matTooltip="Enregistrer"
                      title="Enregistrer">

                      <i class="fa fa-check"></i>
                    </button>

                    <button
                      class="cancel-btn"
                      (click)="onCancelEdit()"
                      matTooltip="Annuler"
                      title="Annuler">

                      <i class="fa fa-times"></i>
                    </button>

                  </div>

                </div>

              </div>

            </td>
          </tr>

        </ng-container>

      </tbody>

    </table>

    <!-- Empty state -->
    <div class="empty-state" *ngIf="!items || items.length === 0">

      <div class="empty-icon">
        <i class="fa fa-envelope-open-o"></i>
      </div>

      <div class="empty-title">
        Aucun envoi automatique
      </div>

      <div class="empty-text">
        Aucun rapport automatique n'est actuellement configuré.
      </div>

    </div>

  </div>

</div>